import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
// import { deleteOffersServer, getOffersServer } from '../../../apis/offersApi'
// import getOffersColumns from '../../../const/Columns/getOffersColumns'
import { Link } from 'react-router-dom'
import { deleteOffersServer, getOffersServer } from '../../../apis/offersApi'
import getOffersColumns from '../../../const/columns/getOfferscolumns'

const Offers = () => {
  const [offers, setOffers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchOffers()
  }, [])

  const fetchOffers = async () => {
    try {
      const res = await getOffersServer()
      setOffers(res.result)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const deleteOffers = async id => {
    const isConfirmed = window.confirm(
      'Are you sure you want to delete this Offers?'
    )
    if (isConfirmed) {
      await deleteOffersServer(id)
      setLoading(true)
      fetchOffers()
    }
  }

  const columns = getOffersColumns(deleteOffers)
  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            <div className='d-flex  justify-content-between  align-items-center'>
              <Link to='/addOffers' className='btn add-new btn-primary mb-3'>
                Add Offers
              </Link>
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className='table-respoinsive'>
                <Table
                  columns={columns}
                  dataSource={offers?.length > 0 ? offers : []}
                  className='table-striped '
                  rowKey={record => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Offers
